<template>
  <div id="app">
    <!-- <div class="main">
    <input type="text" />
    <input type="submit" value="Go">
    </div> -->
    <div class="s003">
      <form>
        <div class="inner-form">
          <div class="input-field first-wrap">
            <div class="input-select">
              <select v-model="category" class="select" data-trigger="" name="choices-single-defaul">
                <option v-for="item in data.category" :key="item.key" :value="item.key">{{item.name}}</option>
              </select>
            </div>
          </div>
          <div class="input-field second-wrap">
            <input id="search" type="text" v-model="search" placeholder="พิมพ์คำค้น เช่น ผู้อำนวยการ" />
          </div>
          <div class="input-field third-wrap">
            <button class="btn-search" type="button">
              <svg class="svg-inline--fa fa-search fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
              </svg>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="last-update-container">
      ข้อมูลอัพเดท: {{data.lastUpdate}}
    </div>
    <div v-if="screenWidth > maxScreenWidth" class="limiter">
      <div class="container-table100">
        <div class="wrap-table100">
          <div class="table100 ver1 m-b-110">
            <div class="table100-head">
              <table class="table-header">
                <thead>
                  <tr class="row100 head">
                    <th class="cell100 col1">{{data.title[0].name}}</th>
                    <th class="cell100 col8">{{data.title[7].name}}</th>
                    <th class="cell100 col7">{{data.title[6].name}}</th>
                    <th class="cell100 col6">{{data.title[5].name}}</th>
                    
                    <th class="cell100 col2">{{data.title[1].name}}</th>
                    <th class="cell100 col3">{{data.title[2].name}}</th>
                    <th class="cell100 col4">{{data.title[3].name}}</th>
                    <th class="cell100 col5">{{data.title[4].name}}</th>
                    
                    
                  </tr>
                </thead>
              </table>
            </div>

            <div class="table100-body js-pscroll">
              <table>
                <tbody>
                  <tr class="row100 body"  v-for="item in filteredList" :key="item.key">
                    <td class="cell100 col1">{{item.name}}</td>
                    <td class="cell100 col8">{{item.position}}</td>
                    <td class="cell100 col7">{{item.section}}</td>
                    <td class="cell100 col6">{{item.org}}</td>
                    <td class="cell100 col2">
                      <span style="white-space: nowrap;">{{formatPhoneNumber(item.phone)}}</span></td>
                    <td class="cell100 col3">{{item.ext}}</td>
                    <td class="cell100 col4">
                      <span style="white-space: nowrap;">{{formatPhoneNumber(item.fax)}}</span></td>
                    <td class="cell100 col5">{{item.mobile}}</td>
                    
                    
                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="mtop-small mobile-size">
      <template v-for="item in filteredList" >
      <div v-if="isValid(item)" class="row" :key="item.key">
        <div class="white-box">
          <div class="row">
            <div class="col">
               <div class="row">
                <!-- <div class="box-phonebook"><img class="icon-phonebook" src="@/assets/phonebook.png"></div> -->
                <div class="box-name">{{item.name}}</div>
              </div>
              <div class="row">
                <div class="box-position">{{item.position}}</div>
              </div>
              <div class="row mtop-medium">
                <div class="box-section">{{item.section}}</div>
              </div>
              <div class="row">
                <div class="box-org">{{item.org}}</div>
              </div>
            </div>
            <!-- <div class="col-4 center">
              <div class="box-phone"><a href="`tel:${formatPhoneNumber(item.phone)}`">{{formatPhoneNumber(item.phone)}}</a></div>
            </div> -->
          </div>
          <hr/>
          <div class="row">
            <div class="col center">
              <div class="box-icon"><img class="icon-phone" src="@/assets/call.png"></div>
              <label class="label-phone"><a :href="`tel:${getTel(item.phone)}`">{{formatPhoneNumber(item.phone)}}</a></label>
            </div>
          </div>
          <hr/>
          <div class="row">
            <div class="col center">
              <div class="box-icon"><img class="icon-phone" src="@/assets/call.png"></div>
              <label class="label-phone"><a :href="`tel:${getTel(item.mobile)}`">{{formatPhoneNumber(item.mobile)}}</a></label>
            </div>
          </div>
         
        </div>
      </div>
      </template>
    </div>
    <div v-if="false" class="row mobile-size mtop-small">
      <div class="col center">
        <label class="label-notfound">ไม่พบข้อมูล</label>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import json from '@/models/phonebook.json'
export default {
  name: 'App',
  components: {
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  data(){
    return{
      data: json,
      search: '',
      category: 'all',
      screenWidth: 1366,
      mobileWidth: 600,
      maxScreenWidth: 768,
      isEmpty: false
    }
  },
  methods: {
    isValid: function (item){
      if(item.name.trim() !== "") {
        return true
      }else{
        return false
      }
    },
    filteredListx: function (){
      return this.data.phonebook
    },
    getTel: function (str){
      str = str.replace('-','')
      if (str.length >= 9){
        if(str[1]=="8" || str[1]=="9"){
          // console.log('if 08 -> ', str.substring(0,10))
          return str.substring(0,10)
        }else{
          // console.log('else -> ', str.substring(0,9))
          return str.substring(0,9)
        }
      }
    },
    formatPhoneNumber: function(str){
      //Filter only numbers from the input
      str = str.replace('-','')
      let cleaned = ('' + str).replace(/\D/g, '')
      let match = []
      //Check if the input is of correct length
      // console.log(str)
      if(str[1]=="8" || str[1]=="9"){
        // match = cleaned.match(/^(\d{2})(\d{7})(\d{1})$/)
        if(str.length == 10){
          match = cleaned.match(/^(\d{3})(\d{7})$/)
        }else if(str.length > 10){
          cleaned = cleaned.substring(0,10)
          match = cleaned.match(/^(\d{3})(\d{7})$/)
        }else{
          match = cleaned.match(/^(\d{2})(\d{7})$/)
        }
        
      }else{
        // match = cleaned.match(/^(\d{3})(\d{6})(\d{1})$/)
        if(str.length >= 9){
          // str = str.substring(0,10)
          // if(str[1] == "2"){
          //   if(str.length >= 9){
          //     match = cleaned.match(/^(\d{2})(\d{7})(\d{1})$/)
          //   }else{
          //     cleaned = cleaned.substring(0,9)
          //     match = cleaned.match(/^(\d{2})(\d{7})$/)
          //   }
          // }else{
            // console.log('ESLE ->')
            cleaned = cleaned.substring(0,9)
            if(str[1] == "2"){
              match = cleaned.match(/^(\d{2})(\d{7})$/)
            }else{
              match = cleaned.match(/^(\d{3})(\d{6})$/)
            }
          // }
          
        }else{
          match = cleaned.match(/^(\d{3})(\d{6})$/)
        }
      }
      // console.log('<<< ',str)
      // console.log(">>> ",cleaned.match(/^(\d{3})(\d{6})(\d{1})$/))
      // if(match == null) {
      //   console.log('match', match, ' cleaned -> ',cleaned)
      // }
      
      if (match) {
        if(match[3]) {
          return  match[1] + '-' + match[2] + '-' + match[3]
        } else {
          return  match[1] + '-' + match[2]
        }
      }

      return null
    },
    handleResize () {
      this.screenWidth = window.innerWidth
      // console.log('Query ->> ', this.$route.query.test)
      let uri = window.location.search.substring(1); 
      let params = new URLSearchParams(uri);
      if(params.get("fullscreen") !== "true") {
        if (this.screenWidth < this.mobileWidth) {
          window.top.location.href = "https://nama-nukrom.web.app/web/?fullscreen=true"; 
          // In admin page add this to iframe sandbox="allow-scripts allow-top-navigation allow-top-navigation"
        }
      }
    }
  },
  computed: {
    filteredList() {
      // console.log("category", this.category)
      let newData = json.phonebook
      let searchText = this.search.trim().replace('-','')
      if (this.category !== "all"){
        if (this.category === 'c12') {
          newData = json.phonebook.filter(d => d.org.includes(json.category.filter(c => c.key == this.category)[0].name.split(' ')[0].replace('บริการ','')) )
        }else{
          newData = json.phonebook.filter(d => d.org === json.category.filter(c => c.key == this.category)[0].name)
        }
      }
      let result = newData.filter(d => d.name.includes(searchText) || d.phone.replace('-','').includes(searchText) || d.ext.includes(searchText) || d.fax.includes(searchText) ||  d.section.includes(searchText) || d.position.includes(searchText))
      // if (result.length == 0 ) {
      //   this.isEmpty = true
      // }else{
      //   this.isEmpty = false
      // }
      return result
      // return this.data.phonebook.filter(post => {
      //   return post.name.toLowerCase().includes(this.search.toLowerCase())
      // })
    }
  }
  
  
}
</script>

<style>
.table-header{
  width: calc(100% - 20px);
}

.white-box{
  margin: 10px 30px;
  /* border: gray solid 1px; */
  width: 100%;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 1px 1px 5px #a7a7a7;
}
.mtop-small {
  margin-top: 10px;
}

.mtop-medium {
  margin-top: 50px;
}

.label-phone{
  font-size: 18px;
}

.container-table100{
  justify-content: center;
}

select{
    height: 68px;
  }

@media only screen and (max-width: 768px) {
  .s003 {
    position: fixed;
    z-index: 9999;
    top: 0;
    
  }
  .mobile-size{
    top: 280px;
    position: absolute;
    width: 100%;
  }
}

/* @media only screen and (max-width: 1366px) {
  .container-table100{
    justify-content: unset;
  }
} */

@media only screen and (max-width: 993px) {
  select{
    height: 50px;
  }
}

.box-name {
  font-size: 24px;
  padding-left: 20px;
  padding-right: 20px;
}
.box-icon {
  padding: 0px 5px;
  /* float: left; */
  left: 28%;
  position: absolute;
  top: -1px;
}

.box-phonebook {
  position: absolute;
  right: 15px;
}
.box-position{
  padding-left: 20px;
  padding-right: 20px;
  font-size: 18px;
  color: #006408;
}
.box-section {
  padding-left: 20px;
  padding-right: 20px;
  font-size: 16px;
  color: #707070;
}
.box-org{
  padding-left: 20px;
  padding-right: 20px;
  font-size: 16px;
  color: #adadad;
}

.center{
  text-align: center;
}
.icon-phone{
  width: 24px;
}
.box-phone{
  line-height: 100px;
}
hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid rgb(228, 228, 228);
    margin: 1em 0;
    padding: 0;
}

.last-update-container {
    position: absolute;
    font-size: 12px;
    color: grey;
    top: 100px;
    right: 0px;
}

</style>
